<template>
  <div class="component-broker-avatar-box">
    <div
      class="component-broker-avatar"
      :style="{width: `${width}px`, height: `${width}px`, border: star == 5 ? '2px solid #FFC904' : 'none'}"
    >
      <img
        :style="`position: absolute;top: -29%;right: -2%;width: 60%;`"
        src="../../assets/images/star-5.png"
        v-if="star == 5"
      >
      <el-image
        class="component-broker-avatar-inner"
        :style="`position: absolute;top: 50%;left: 50%;width: ${innerWidth}px; height: ${innerHeight}px; margin-top: -${innerHeight/2}px; margin-left: -${innerWidth/2}px`"
        :src="url"
        fit="fill"
      ></el-image>
    </div>
    <div
      class="component-broker-avatar-star"
      v-if="star && star >= 0"
    >
      <template v-for="num in parseInt(star)">
        <img
          :style="{width: `${width/6}px`}"
          src="../../assets/images/star-full.png"
          :key="num"
          alt=""
        >
      </template>
      <template v-if="star > parseInt(star)">
        <img
          :style="{width: `${width/6}px`}"
          src="../../assets/images/star-half.png"
          alt=""
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ["width", "url", "star"],
  data() {
    return {};
  },

  components: {},

  computed: {
    innerWidth() {
      return parseInt(this.width) - 4;
    },
    innerHeight() {
      return parseInt(this.width) - 4;
    },
  },

  methods: {},
};
</script>
<style scoped>
.component-broker-avatar-box{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.component-broker-avatar {
  border-radius: 50%;
  position: relative;
  box-sizing: border-box;
}
.component-broker-avatar-inner {
  border-radius: 50%;
  overflow: hidden;
  z-index: 3;
}
.component-broker-avatar-star {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.component-broker-avatar-star img {
  margin-right: 1px;
}
</style>


// WEBPACK FOOTER //
// avatar.vue?43a89cd9